"use client";

import { mergeProps } from "@react-aria/utils";
import { type LabelHTMLAttributes } from "react";

import { cn } from "../../utils";
import { useTextFieldRootContext } from "./context";

export type TextFieldLabelProps = LabelHTMLAttributes<HTMLLabelElement>;

const Label = (props: TextFieldLabelProps) => {
  const { textField } = useTextFieldRootContext();

  const mergedProps = mergeProps(props, textField?.labelProps);

  return (
    <label {...mergedProps} className={cn("text-neutral-10 font-semibold text-sm leading-5", mergedProps.className)}>
      {mergedProps.children}
    </label>
  );
};

export default Label;
